import React, {useContext, useMemo, useState,} from 'react'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {BsArrowLeftCircle, BsFolder2Open, BsFolderFill, BsGearFill, BsImage, BsPlus, BsTrash} from "react-icons/bs";
import {TabNavigation} from '../../../Shared/components/TabNavigation'
import _ from "lodash"
import useTranslate from "../../../../modules/local/useTranslate";
import {useRouterSearchParam} from "../../../../modules/navigation/useOnLocationChange";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import classNames from "classnames";
import {AiFillDelete} from "react-icons/ai";
import {image_directDestroy_Api, image_directUpload_Api} from "../../../../apis";
import {ShopContainerContext} from "./ShopContainer";
import {ProductFormEdit} from "../../../AppLocals/Shop/components/ProductForm";
import CRUD from "../../../Shared/enums/CRUD";
import {useProductForm} from "../../../AppLocals/Shop/functions/useProductForm";
import CustomButton from "../../../AppLocals/custom/CustomButton";
import {renderIf} from "../../../Shared";
import {Avatar, Button, Checkbox, Empty, Image, Input, Upload} from "antd";
import {showDeleteConfirmDialog} from "../../../AppLocals/factory/createConfirmDialog";
import {useImageActions} from "../functions/useImageActions";
import {callApi} from "../../../../modules/asyncCache/callApi";
import {bindQueryParam, bindQueryParams} from "../../../AppLocals/functions/routerHelper";
import {STORAGE_URL} from "../../../../envs/_current/config";
import ImgCrop from 'antd-img-crop'
import DrawDialog from "../../../../components/drawer/dialog/DrawDialog";
import SearchOutlined from "@ant-design/icons/lib/icons/SearchOutlined";
import useProductActions from "../../../AppLocals/Shop/functions/useProductActions";
import {renderMaskImage} from "../../../../components/renderFunctions/renderMaskImage";
import {IoFolderOpenOutline} from "react-icons/io5";

const TABS_CONFIG = [
    {
        key: 'photos',
        name: 'photos',
        icon: <BsImage size={18}/>,
    },
    {
        key: 'catalogs',
        name: 'catalogs',
        icon: <BsFolderFill size={18}/>,
    },
    {
        key: 'settings',
        name: 'product settings',
        icon: <BsGearFill size={16}/>,
    },
    {
        key: 'destroy',
        name: 'delete content',
        icon: <AiFillDelete size={16}/>,
    },
];

const ProductImageUpload = ({product, fileList, setFileList, onChange, children}) => {
    const t = useTranslate();

    return (
        <ImgCrop
            rotationSlider
            modalTitle={
                <div className="text-center font-bold text-color-000 tracking-wide">
                    {t('preview and edit photo')}
                </div>
            }
            modalWidth={800}
            aspect={4 / 3}
            modalClassName="custom-modal-img-crop"
            modalOk={t('complete')}
            modalCancel={
                <span className="text-color-200 hover:text-color-000">
                    {t('cancel')}
                </span>
            }>
            <Upload
                // multiple={true}
                accept=".jpg,.jpeg,.png,.webp"
                listType="picture"
                fileList={fileList}
                onChange={onChange}
                customRequest={async ({onSuccess, ...args}) => {
                    const response = await callApi({
                        apiInfo: image_directUpload_Api,
                        values: {
                            'photos[]': args.file,
                        },
                        query: bindQueryParams([
                            {type: 'product'},
                            {id: product?.id},
                        ]),
                    })
                    const newFileList = _.map(fileList, (item) =>
                        item.uid === args?.file?.uid
                            ? {
                                ...args?.file,
                                id: _.get(response, 'data.ids.0'),
                                status: 'done',
                                url: (_.get(response, 'data.urls.0') || '').startsWith('http')
                                    ? _.get(response, 'data.urls.0')
                                    : `${STORAGE_URL}/${_.get(response, 'data.urls.0')}`,
                            }
                            : item
                    )
                    setFileList(newFileList)
                }}
                onRemove={async (file) => {
                    const newFileList = fileList.filter((item) => item.uid !== file.uid)
                    setFileList(newFileList)
                    const response = await callApi({
                        apiInfo: image_directDestroy_Api,
                        query: bindQueryParam({id: file.id}),
                    })
                }}
                showUploadList={false}>
                {children}
            </Upload>
        </ImgCrop>
    )
}

const ProductPhotos = ({product}) => {
    const t = useTranslate()
    const [fileList, setFileList] = useState(
        _.get(product, 'photos', []).map((e) => ({
            ...e,
            uid: e.id,
            name: e.id,
            url: e.path,
            status: 'done',
        }))
    )

    const _height = 120

    const {
        onDirectUpload,
        onDirectDelete,
        onMultiDirectDelete,
    } = useImageActions({
        notifyListeners: {
            onCreated: (result, data) => {

            },
            onDeleted: (result, data) => {

            },
            onMultiDeleted: (result, data) => {

            },
        },
    })

    const onChange = ({fileList: newFileList}) => {
        setFileList(newFileList);
    };

    const [selectedFiles, setSelectedFiles] = useState([]);

    // select all ảnh
    const handleSelectAll = () => {
        setSelectedFiles(fileList.map((file) => file.uid));
    };

    // deselect all ảnh
    const handleDeselectAll = () => {
        setSelectedFiles([]);
    };

    // Chọn ảnh để xóa nhiều ảnh cùng lúc
    const handleSelectFile = (file, checked) => {
        setSelectedFiles((prev) =>
            checked ? [...prev, file.uid] : prev.filter((id) => id !== file.uid)
        );
    };

    // Xóa nhiều ảnh cùng lúc
    const handleRemoveSelected = () => {
        showDeleteConfirmDialog({
            translate: t,
            title: 'delete photos',
            message: `${t('are you sure you want to delete photos')} ?`,
            onOk: () => {
                onMultiDirectDelete({ids: selectedFiles.join(",")})
                setFileList((prev) => prev.filter((file) => !selectedFiles.includes(file.uid)));
                setSelectedFiles([]); // Reset danh sách đã chọn
            },
        })
    };


    return (
        <>
            <div className="mb-3 pb-3 border-b border-color-50 flex items-center gap-2 overflow-x-auto">
                <ProductImageUpload {...{product, fileList, setFileList, onChange}}>
                    <CustomButton
                        ift="add"
                        color="primary"
                        variant="solid"
                        label="add photo"
                        textSize="text-xs"
                        style={{ height: 28 }}
                    />
                </ProductImageUpload>
                <div className="flex-1"/>
                <CustomButton
                    ift="select-all"
                    color={selectedFiles.length === fileList.length ? "default" : "primary"}
                    variant="filled"
                    label="select all"
                    textSize="text-xs"
                    onClick={handleSelectAll}
                    style={{ height: 28 }}
                />
                <CustomButton
                    ift="deselect-all"
                    color={selectedFiles.length === 0 ? "default" : "primary"}
                    variant="filled"
                    label="deselect all"
                    textSize="text-xs"
                    onClick={handleDeselectAll}
                    style={{ height: 28 }}
                />
                {renderIf(
                    selectedFiles.length > 0,
                    <CustomButton
                        ift="delete-all"
                        color="primary"
                        variant="text"
                        label={
                            selectedFiles.length === fileList.length ? 'delete all' :
                                selectedFiles.length > 0 ? t("delete {n} selected photos", {n: selectedFiles.length}) : 'delete'
                        }
                        textSize="text-xs"
                        onClick={handleRemoveSelected}
                        style={{ height: 28 }}
                    />
                )}
            </div>
            <Image.PreviewGroup>
                <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
                    {fileList.map((file, index) => {
                        return (
                            <div key={index} className="relative">
                                <Image
                                    loading="lazy"
                                    key={index}
                                    src={file.url || file.preview}
                                    style={{minHeight: _height}}
                                    wrapperClassName={classNames("rounded-lg", selectedFiles.includes(file.uid) && 'border border-primary')}
                                    className="object-cover rounded-lg cursor-pointer"
                                    preview={{mask: renderMaskImage()}}
                                />
                                <div className="absolute top-5 left-5">
                                    <Checkbox
                                        className="flex cursor-pointer"
                                        onChange={(e) => handleSelectFile(file, e.target.checked)}
                                        checked={selectedFiles.includes(file.uid)}
                                    />
                                </div>
                            </div>
                        )
                    })}
                </div>
            </Image.PreviewGroup>
        </>
    )
}

const getLeafNodes = (data) => {
    return _.flatMap(data, item => {
        if (_.isEmpty(item.children)) {
            return [item]; // leaf
        }
        return getLeafNodes(item.children); // duyệt xuống sâu hơn
    });
}

const ProductCatalogs = ({product, shop}) => {
    const t = useTranslate();
    const catalogs = getLeafNodes(_.get(shop, 'product_catalogs', []));
    const [selectedIds, setSelectedIds] = useState(
        _.map(_.get(product, 'product_catalogs', []), 'id')
    );
    const [searchTerm, setSearchTerm] = useState('');

    const handleRemoveCatalog = (id) => {
        setSelectedIds((prev) => prev.filter((catId) => catId !== id));
    };

    const handleAddCatalog = (id) => {
        if (!selectedIds.includes(id)) {
            setSelectedIds((prev) => [...prev, id]);
        }
    };

    const selectedCatalogs = useMemo(() => {
        return catalogs?.filter(c => selectedIds.includes(c.id));
    }, [selectedIds]);

    const availableCatalogs = useMemo(() => {
        // Lọc ra các catalog chưa được chọn VÀ khớp với từ khóa tìm kiếm
        return catalogs?.filter(c =>
            !selectedIds.includes(c.id) &&
            c.title.toLowerCase().includes(searchTerm?.toLowerCase())
        );
    }, [selectedIds, searchTerm]);

    const {
        createNewProduct,
        editProductInfo,
        deleteProduct,
        publishProduct,
        addVariant,
        editVariantInfo,
        deleteVariant
    } = useProductActions({
        notifyListeners: {}
    })

    const {product_variants = []} = product ?? {}

    return (
        <div className="w-full bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col my-auto border border-color-50">
            <div className="p-3 border-b border-gray-100 flex items-center gap-3 sticky top-0 z-10">
                <div className="flex flex-col flex-1">
                    <h1 className="font-bold text-lg text-gray-800 leading-tight">
                        {t('product categorization')}
                    </h1>
                    <span className="text-xs text-color-300 tracking-wider">
                        {t('edit catalog')}
                    </span>
                </div>
                <Button
                    color="primary" variant="filled"
                    onClick={() => {editProductInfo({product_catalog_ids: selectedIds.join(",")}, {id: product?.id})}}
                    className="font-semibold">
                    {t('save')}
                </Button>
            </div>

            {/* --- PRODUCT INFO SUMMARY --- */}
            <div className="p-3 flex items-start gap-3 border-b border-blue-100">
                <img
                    src={product?.avatar}
                    alt="Product"
                    className="w-16 h-16 rounded-lg object-cover border border-white shadow-sm flex-shrink-0"
                />
                <div className="flex flex-col flex-1">
                    <h3 className="font-bold text-base text-gray-800 mb-1">
                        {product?.title}
                    </h3>
                    <div className="flex items-center gap-1 font-semibold text-sm text-blue-600 tracking-wider">
                        <span className="font-normal text-color-300">SKU:</span>
                        {product_variants[0]?.variant_code}
                    </div>
                </div>
            </div>

            {/* --- BODY: LIST SELECTED CATALOGS --- */}
            <div className="flex-1 overflow-y-auto p-4 bg-white">
                <div className="flex justify-between items-center mb-4">
                    <div className="text-sm font-medium text-color-200 tracking-wider">
                        {t('selected catalog')} ({selectedCatalogs.length})
                    </div>
                </div>
                {selectedCatalogs.length === 0 ? (
                    <div className="flex flex-col flex-center gap-2 py-10 rounded-lg border border-color-50 shadow-md">
                        <IoFolderOpenOutline size={40} className="text-color-500"/>
                        <div className="text-center text-color-300 tracking-wider">
                            {t('Products not assigned to any category')}
                        </div>
                    </div>
                ) : (
                    <div className="flex flex-col gap-3">
                        {selectedCatalogs.map((cat) => {
                            return (
                                <div
                                    key={cat.id}
                                    className="p-3 flex items-center border border-color-50 rounded-lg shadow-sm">
                                    <div className="flex flex-col flex-1">
                                        {cat?.parent && (
                                            <div className="font-medium text-xs text-indigo-500 italic tracking-wider">
                                                {cat?.parent?.title}
                                            </div>
                                        )}
                                        <div className="font-bold text-base text-color-000 tracking-wide">{cat.title}</div>
                                    </div>
                                    <BsTrash
                                        size={18}
                                        onClick={() => handleRemoveCatalog(cat.id)}
                                        className="opacity-85 hover:opacity-100 text-red-500 hover:text-primary cursor-pointer"
                                    />
                                </div>
                            )
                        })}
                    </div>
                )}
            </div>

            {/* --- FOOTER ACTION --- */}
            <div className="p-4 border-t border-gray-100 bg-white sticky bottom-0 safe-area-bottom">
                <DrawDialog
                    width={600}
                    component={
                        <Button
                            block size="large"
                            type="dashed" icon={<BsPlus size={19}/>}
                            className="w-80 mx-auto font-medium text-blue-600 border-blue-300">
                            {t('add catalog')}
                        </Button>
                    }
                    title={
                        <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                            {t('add catalog')}
                        </div>
                    }>
                    {(isToggle, toggle) => {
                        return isToggle && (
                            <div className="flex flex-col h-full">
                                {/* Search Input Sticky */}
                                <div className="sticky top-0 z-10">
                                    <Input
                                        allowClear
                                        prefix={<SearchOutlined className="text-gray-400"/>}
                                        placeholder={`${t('search catalog')}...`}
                                        size="large"
                                        className="rounded-lg background-50 hover:bg-white focus:bg-white"
                                        value={searchTerm}
                                        onChange={(e) => setSearchTerm(e.target.value)}
                                    />
                                </div>

                                {/* List Available Items */}

                                <div className="mx-2 mt-2 mb-1 pb-1 border-b border-color-50 font-bold text-color-200 uppercase tracking-wider">
                                    {t('suggested for you')}
                                </div>
                                <div className="p-2 flex-1 overflow-y-auto">
                                    {availableCatalogs.length === 0 ? (
                                        <Empty description="no categories found" className="mt-10"/>
                                    ) : (
                                        <div className="flex flex-col gap-4">
                                            {availableCatalogs.map((cat) => {
                                                return (
                                                    <div
                                                        key={cat.id}
                                                        onClick={() => handleAddCatalog(cat.id)}
                                                        className="px-3 py-2 flex items-center border border-color-50 hover:shadow-md hover:scale-2xs rounded-lg cursor-pointer">
                                                        <div className="flex items-center flex-1 gap-3">
                                                            <Avatar
                                                                shape="square"
                                                                size="small"
                                                                icon={<BsFolder2Open className="text-color-300"/>}
                                                                className="flex flex-center background-200"
                                                            />
                                                            <div className="flex flex-col">
                                                                {cat?.parent && (
                                                                    <div className="font-medium text-xs text-indigo-500 italic tracking-wider">
                                                                        {cat?.parent?.title}
                                                                    </div>
                                                                )}
                                                                <div className="font-bold text-base text-color-000 tracking-wide">
                                                                    {cat.title}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <Button size="small" color="primary" variant="filled"
                                                                className="font-medium text-xs rounded-md">
                                                            {t('choose')}
                                                        </Button>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                    )}
                                </div>

                                {/* Drawer Footer info */}
                                <div
                                    className="p-2 background-50 rounded-md text-center text-sm text-color-200 italic safe-area-bottom">
                                    {t('currently showing')} <strong
                                    className="text-color-000">{availableCatalogs.length}</strong> {t('available catalogs')}
                                </div>
                            </div>
                        )
                    }}
                </DrawDialog>
            </div>
        </div>
    );
}


const ProductDetail = ({product, shop}) => {
    const t = useTranslate();
    const productDetailTab = useRouteSearchParam("product-detail-tab") || "settings"
    const [activeTab, setActiveTab] = useState(productDetailTab);
    const {
        current_shop_id, setCurrentShopId,
        current_product_id, setCurrentProductId,
        onSelectShopContainerRoute
    } = useContext(ShopContainerContext);

    const {onChangeSearchParams} = useRouterSearchParam({})

    const {
        modal: productModal,
        handleAction: handleProductAction,
        onCancel: onProductCancel,
        refreshKey: refreshProductKey,
        createNewProduct,
        editProductInfo,
        deleteProduct,
        publishProduct,
        addVariant,
        editVariantInfo,
        deleteVariant
    } = useProductForm({shop})


    const renderTabContent = () => {
        switch (activeTab) {
            case 'photos':
                return (
                    <div className="flex flex-col gap-4">
                        <div className="flex flex-col gap-1">
                            <h3 className="font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("photos")}
                            </h3>
                            <span className="text-xs text-color-300 italic tracking-wider">
                                {`* ${t('upload photo descriptions')}`}
                            </span>
                        </div>
                        <ProductPhotos product={product}/>
                    </div>
                );
            case 'catalogs':
                return (
                    <div className="flex flex-col">
                        <h3 className="mb-4 font-bold text-base text-gray-700 tracking-wide uppercase">
                            {t("catalogs")}
                        </h3>

                        <ProductCatalogs product={product} shop={shop}/>

                    </div>
                );

            case 'settings':
                return (
                    <div className="flex flex-col">
                        <h3 className="mb-2 font-bold text-base text-gray-700 tracking-wide uppercase">
                            {t("product settings")}
                        </h3>
                        {/*<div className="my-3 flex flex-col gap-1">*/}
                        {/*    <label className="text-sm font-medium text-color-200 tracking-wider">*/}
                        {/*        {t('belong to the shop')}*/}
                        {/*    </label>*/}
                        {/*    <div className="p-3 flex flex-col border border-color-50 shadow rounded-lg">*/}
                        {/*        <div className="mb-2 pb-2 border-b border-color-100 flex items-center gap-2">*/}
                        {/*            <span className="font-bold text-base text-color-000 tracking-wide">*/}
                        {/*                {getTitle(shop)}*/}
                        {/*            </span>*/}
                        {/*        </div>*/}
                        {/*        <div className="flex flex-col flex-1 gap-1">*/}

                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}

                        {!!product?.id && (
                            <ProductFormEdit
                                item={product}
                                owner_id={shop?.owner?.id}
                                owner_type={shop?.owner?._type}
                                container={shop}
                                initialValues={product}
                                onCancel={onProductCancel}
                                onSubmit={(values) => {
                                    editProductInfo(values, {id: product?.id})
                                }}
                            />
                        )}

                    </div>
                );
            case 'destroy':
                return (
                    <div className="flex flex-col">

                        <div className="bg-white p-4 rounded-xl shadow-lg border-l-4 border-red-500">
                            <h3 className="mb-2 font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("delete product")}
                            </h3>
                            <div className="mb-4 text-color-300 tracking-wider">
                                {t("delete product description")}
                            </div>
                            <div className="flex justify-end">
                                <button
                                    onClick={() => {
                                        handleProductAction(CRUD.DELETE, product)
                                    }}
                                    className="px-6 py-2 bg-red-600 hover:bg-red-700 shadow-md rounded-lg font-medium text-white">
                                    {t("delete product permanently")}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="w-full min-h-screen">
            <div className="mb-6 p-4 background shadow-lg rounded-b-xl stickyTop1 z-12">
                <button
                    onClick={() => {
                        onSelectShopContainerRoute({current_product_id: ''})
                    }}
                    className="mb-2 flex items-center text-color-300 hover:text-color-100 tracking-wide cursor-pointer">
                    <BsArrowLeftCircle size={18} className="mr-2"/>
                    {`${t("back to shop list")} :`}
                    <span className="ml-1 font-medium text-primary-800 italic">
                        {shop?.title}
                    </span>
                </button>
                <Link to={getLinkToDetail(product)} className="no-underline">
                    <h1 className="font-bold text-2xl text-gray-800 tracking-wide">
                        {product?.title}
                    </h1>
                </Link>
            </div>

            <TabNavigation
                tabs={TABS_CONFIG}
                activeTab={activeTab}
                className="mt-6 border-color-300"
                style={{top: 'calc(3 * var(--header-height))', zIndex: 12}}
                onTabChange={(value) => {
                    onChangeSearchParams({"product-detail-tab": value})
                    setActiveTab(value)
                }}/>

            {/* Nội dung Tab */}
            <div className="p-3 md:p-6 background rounded-b-xl shadow-lg">
                {renderTabContent()}
            </div>

            {productModal}
            <div className="h-16"/>
        </div>
    );
};


export default ProductDetail
